import { Grid } from "@mui/material";
import { DisinfectionFilterButtons } from "components/modules/disinfectionFilter/DisinfectionFilterButtons";
import {
  DisinfectionFilterPanel,
  useDDFilter,
} from "components/modules/disinfectionFilter/DisinfectionFilterPanel";
import { DisinfectionTimeRangeFilterPanel } from "components/modules/disinfectionFilter/DisinfectionTimeRangeFilterPanel";
import { DisinfectionFilter } from "gql/graphql";
import { useState } from "react";
import { getSelectedFilterList } from "utils/UVD/getSelectedFilterList";

interface Props {
  hiddenFilter?: DisinfectionFilter;
}

export const DisinfectionDashboardFilter = ({ hiddenFilter }: Props) => {
  const [DDFilters, setDDFilter] = useDDFilter();
  const [generalFilterDrawerOpen, setGeneralFilterDrawerOpen] = useState(false);
  const [timerangeFilterDrawerOpen, setTimerangeDrawerOpen] = useState(false);

  const setBothDates = (start: Date, end: Date) => {
    const newStart = new Date(start);
    newStart.setHours(0, 0, 0, 0);
    const newEnd = new Date(end);
    newEnd.setHours(23, 59, 59, 999);

    setDDFilter({
      ...DDFilters,
      timeSpan: {
        start: newStart.toUTCString(),
        end: newEnd.toUTCString(),
      },
    });
  };

  const startDate = new Date(DDFilters.timeSpan.start);
  const endDate = new Date(DDFilters.timeSpan.end);

  return (
    <>
      <Grid item>
        <DisinfectionFilterButtons
          startDate={startDate}
          endDate={endDate}
          filterCount={getSelectedFilterList(DDFilters).length || 0}
          onOpenGeneralFilterDrawer={() => setGeneralFilterDrawerOpen(true)}
          onOpenTimeRangeFilterDrawer={() => setTimerangeDrawerOpen(true)}
        />
      </Grid>
      <DisinfectionFilterPanel
        open={generalFilterDrawerOpen}
        onClose={() => setGeneralFilterDrawerOpen(false)}
        hiddenFilter={hiddenFilter}
      />
      <DisinfectionTimeRangeFilterPanel
        open={timerangeFilterDrawerOpen}
        onClose={() => setTimerangeDrawerOpen(false)}
        startDate={startDate}
        endDate={endDate}
        setBothDates={setBothDates}
      />
    </>
  );
};
